<template>
  <div>
    <confirm-modal @cancel-edition="$emit('cancel-edit')" @confirm-edition="confirm" v-if="toggleConfirmationModal"></confirm-modal>
    <div class="title">
      <h3 class="left">Edition Client</h3>
      <button class="btn btn-danger btn-sm" @click="$emit('cancel-edit')">Annuler</button>
    </div>
    <resource-form :schema="schema" :model="model" @submit="finishEditing" :triggers="triggers" ></resource-form>
  </div>
</template>

<script>
  import resourceForm from 'components/Forms/ResourceForm'
  import confirmModal from './ConfirmModal'
  export default {
    props: [ "schema", "model", "triggers" ],

    data () {
      return {
        toggleConfirmationModal:false,
        datasToSend:null,
      }
    },

    components: {
      resourceForm,
      confirmModal,
    },

    methods: {
      finishEditing ($event) {
        this.datasToSend = $event
        if (this.datasToSend.data.customer.tva_intra != null)
          this.toggleConfirmationModal = true
        else {
          this.confirm()
        }
      },

      confirm() {
        this.$emit('finish-edit', this.datasToSend)
        this.datasToSend = null
        this.toggleConfirmationModal = false
      },
    }
}
</script>



// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/Edit/General.vue